import { BaSeParagraph, BaSeTheme } from '@base/react';
import React from 'react';
import { useCandidateInterview } from '../../../hook/useCandidateInterview';

function ConfirmGenerateCertificate({ initialDate, finalDate, cargaHoraria }) {
  const { formatDate } = useCandidateInterview();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        padding: '20px 0px',
      }}
    >
      <BaSeParagraph>
        Tem certeza que deseja gerar o(s) certificado(s) para o(s) candidato(s)?
      </BaSeParagraph>
      <div>
        <BaSeParagraph>
          As datas definidas de realização do seminário foram:{' '}
        </BaSeParagraph>
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          Data de início: {formatDate(new Date(initialDate))}
        </BaSeParagraph>
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          Data de término: {formatDate(new Date(finalDate))}
        </BaSeParagraph>
      </div>
      <div>
        <BaSeParagraph>E a carga horária informada foi de: </BaSeParagraph>
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          {cargaHoraria}h
        </BaSeParagraph>
      </div>
      <BaSeParagraph>
        Uma vez emitido o(s) certificado(s), essa ação não poderá ser desfeita.
      </BaSeParagraph>
    </div>
  );
}

export default ConfirmGenerateCertificate;
